import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CommonMethodService } from 'src/app/core/services/common.method-service';
import { CreateQuoteService } from 'src/app/core/services/create-quote-service';
import { DatePipe, formatDate } from '@angular/common';
import { NewQuoteService } from 'src/app/core/services/new-quote.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { PaymentPendingService } from 'src/app/core/services/payment-pending.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { NewProposalService } from 'src/app/core/services/new-proposal.service';
import { ActivatedRoute, Router } from '@angular/router';
import product_related from 'src/assets/FAQs/marineopen-customer_faqs/product_related.json';
import general from 'src/assets/FAQs/marineopen-customer_faqs/general.json';
import { customerProposalService } from 'src/app/core/services/customerProposal.service.';
import JSZip from 'jszip';
import { UploadedFileObj } from 'src/app/core/models/uploadedDocumentDetails';
import { CommonService } from 'src/app/core/services/common-service';
import { PreviousPolicyDetailsComponent } from '../../new-proposal/previous-policy-details/previous-policy-details.component';
import { FinancierDetailsComponent } from 'src/app/shared/components/financier-details/financier-details.component';
import { RejectProposal, EditCustomerProposalSaveModal, CustomerProposalListModal, getOTPForCustomerProposalAcceptanceModel, validateOTPForCustomerProposalAcceptanceModel, FinancierDetails } from 'src/app/core/models/customerProposalDetails';
import { updateProposalToPolicyModel } from 'src/app/core/models/updateProposalToPolicy';
import { HttpErrorResponse } from '@angular/common/http';
import { CommodityDetails, RiskDetailsMarineOpen, MarineOpenProposalModal, conditionsClausesWarrantiesExclusions, customerDetails, mailingAddress, VoyageDetails, RiskFeature, DeductibleDetails, OverrageExtra } from 'src/app/core/models/marineOpenProposal';
import { type } from 'jquery';
// import { type } from 'os';
// import { type } from 'os';
import { CustomerCommDetails } from 'src/app/core/models/customercommunicationdetails';
import { intermediaryDetailsModel } from 'src/app/core/models/QuoteModel';
import { MarineProposalModel } from 'src/app/core/models/marineproposalmodel';
declare var $: any;

@Component({
  selector: 'app-mo-customer-proposal',
  templateUrl: './mo-customer-proposal.component.html',
  styleUrls: ['./mo-customer-proposal.component.css'],
  standalone: false
})
export class MoCustomerProposalComponent implements OnInit {
  setRotate0: boolean = false;
  setRotate1: boolean = false;
  setRotate2: boolean = false;
  setRotate3: boolean = false;
  setRotate4: boolean = false;
  setRotate5: boolean = false;
  setRotate6: boolean = false;
  setRotate7: boolean = false;
  setRotate8: boolean = false;
  setRotate9: boolean = false;
  refactoredJsonObj: any = [];
  previousPolicyData = [];
  token: any = '';
  searchText: any;
  filtersLoaded: Promise<boolean>;
  dataToDownloadBrochure = {
    productCode: '',
    documentType: 'BROCHURE'
  };
  @ViewChild('validatePrevPolicyDetailsComponent', { static: true, read: PreviousPolicyDetailsComponent }) private PreviousPolicyDetailsComponent: PreviousPolicyDetailsComponent;
  @ViewChild('validateFinancierDetailsComponentForm', { static: true, read: FinancierDetailsComponent }) private financierDetailsComponent: FinancierDetailsComponent;
  financierDetailsFormValid: boolean;
  dataToDownloadPolicyWordings = { productCode: '', documentType: 'POLICYWORDINGS' }
  generalFAQs: { question: string, is_answer_multiple: boolean, answer: string[] }[] = product_related;
  generalallFAQs: { question: string, is_answer_multiple: boolean, answer: string[] }[] = general;
  CCWEInfo: any;

  customerRejectCommentsDetails = {
    comment: '',
    userCode: '',
    createdBy: '',
    time: '',
  }
  marineProposalModel = new MarineProposalModel('', '', '', '', '', '', '', '', '', '', {}, {}, {}, [], {}, {}, false, '', false, '', '', '', {}, [], {}, {}, {}, {}, '', {}, '', '', false);
  endorementTypeList: any;
  selectedEndorsementTypes = [];
  IntermediaryDetailsFromProfile: any;
  isincresedSumInsuredChecked: boolean;
  isChangeInDeclarationChecked: boolean;
  isChangeinDeductibleChecked: boolean;
  isAnyOtherNonNilEndorsementChecked: boolean;
  isUPDateGSTNChecked: boolean;
  firstInvalidControl: HTMLElement;
  masterDataForWC: any;
  financierDetails = new FinancierDetails();
  date: Date;
  currentDate: number;

  customer: any;
  productCode = '2153';
  voyageType: any;
  isQuotePremiumCalculated!: boolean;
  proposalsToPolicyParams = new updateProposalToPolicyModel();
  quoteDetails: any;
  riskDetailsMarineOpen: RiskDetailsMarineOpen;
  overrageExtra: OverrageExtra;
  riskFeature: RiskFeature;
  deductable: DeductibleDetails;
  voyageDetails: VoyageDetails;
  isPinCodeValid: boolean;
  ifProposalRejected = false;
  ifProposalAccepted = false;
  isEditCustomerProposal = false;
  isCustomerProposalMakePayment = false;
  premiumBreakUpAddonCovglist = [
    ['Terrorism Premium', null],
    ['Terrorism for Add-on  Premium', null],
    ['Forest Fire Premium', null],
    ['Architects, Surveyors Premium', null],
    ['Loss of Rent Premium', null],
    ['Additional Expense of Rent Premium', null],
    ['Removal of Debris Premium', null],
    ['Impact Damage Premium', null],
    ['Omission Premium', null]
  ];
  premiumBreakUpBasicCovglist = [
    ['Basic Premium', null],
    ['STFI Premium', null],
    ['Earthquake Premium', null]
  ]
  rejectCustomerProposal = new RejectProposal();
  tempProposalNumber: string;
  acceptProposalOtpResponse: any;
  dataForPdf: any;
  blob: Blob;
  isOTPInvalid: boolean;
  isOTPTimedOut: boolean;
  paymentResponse: any;
  financierList = [];
  invoiceList = [];
  salutationList: any;
  customerTypeList: any;
  masterDataForQuote: any;
  agreementData: any;
  customerProposalTotalResponse: any;
  customerProposalRateList: any;
  policyStartDate: any;
  DateofBirthEditProposal: any;
  isCheckSelected = false;
  isCustomerProposalMakePaymentSuccess: boolean;
  customerProposalEditParams: any = {

  };
  coveragesList = [];
  coverageItem = {
    coverageName: '',
    sumInsured: '',
    indemnityPeriod: ''
  };
  saveEditCustomerProposalList = new EditCustomerProposalSaveModal();
  customerProposalList = new CustomerProposalListModal();
  customerProposalEdit = new CustomerProposalListModal();
  submitted = false;
  isDobInvalid: boolean;
  dobFutureDate: boolean;
  isMobilenumber2InValid: boolean;
  isMobilenumberInValid: boolean;
  isAlEmailIdInValid: boolean;
  isEmailIdInValid: boolean;
  isPolicyStartDate: boolean;
  isPaymentByAgentBehalfIndicator: any;
  isPinCodeInvalid: boolean;
  PincodeMasterData: any;
  PinCodeList: any;
  promise: any;
  ifRequestAgentToPayment: boolean;
  isPaymentBehalfCustomer: boolean;
  isCustomerRejectionCommentsInvalid: boolean;
  emptyFieldError: boolean;
  selectedType: any;
  isInclusionofFinancierChecked: any;
  isAnyOtherNilEndorsementChecked: boolean;
  isChangeinClientDetailsChecked: boolean;
  endorsementType: any;
  disableAllEn = false;
  isEndorsement = false;
  newPolicyDetails: any;
  oldPolicyDetails: any;
  premiumAfterCalculateNull: boolean;
  masterDataForMarine: any;
  lineOfBusinessCode: string = '';
  businessValidations: any = {};
  policyEndDate: any;

  lobAndProductList = {};
  lobList: any;
  productData: any;
  formatblAwbLRrrCnDate: any;
  isCustomerTypeInvalid: boolean;
  customerDetailsList: any;
  searchParams = {
    imdCode: '',
    token: this.token,
  };
  customerDetailsForGetOtpParams = new getOTPForCustomerProposalAcceptanceModel();
  customerDetailsForValidateOtpParams = new validateOTPForCustomerProposalAcceptanceModel();

  inputForPayment = {
    paymentDetails: {
      transactionId: '94204CE9030820162402E1DK',
      amount: 0,
      productInfo: '',
      firstName: '',
      emailAddress: '',
      phoneNumber: '',
      proposalNo: '',
      activityName: 'customer proposal'
    }
  };
  proposalInput = {
    proposalNumber: ''
  };
  maskedMobileNumber: string;
  uploadedDocumentCount = 0;
  uploadedDocumentList;
  docDataSet = {};
  uploadedFilesList = [];
  marineOpenProposalModel: MarineOpenProposalModal;
  voyageTypes: any;
  maillingAddress: mailingAddress;
  customerDetails: customerDetails;
  conditionsClausesWarrantiesExclusions: conditionsClausesWarrantiesExclusions;
  showTypeOfLandConveyance: boolean;
  notNilEndorsement: boolean;
  proposalDataByNumber: any;
  EndorsementDate: any;
  reasons: any[];
  isAtleastOneEndorsmentNotSelected: boolean;
  endorsementNumber: any;
  policyEndDateToSavePeoposal: any;
  policyStartDateToSavePeoposal: any;
  DateOfBirthToSavePeoposal: any;
  proposalResponse: any;
  disableControls: boolean;
  isPremiumCalculated: boolean;
  proposalNo: any;
  proposalStatus: any;
  isEditMode: boolean;
  documentInputFrom = '';
  inputForDocumentComponent: any;
  isDocumentUploaded: boolean;
  quoteNumber: any;
  pincodeminlimit: boolean;
  customerCommunicationDetails: any;
  isPolicyDateInvalid: boolean;




  constructor(private newProposalService: NewProposalService, public commonService: CommonService, public datepipe: DatePipe, private newQuoteService: NewQuoteService, private router: Router,
    private route: ActivatedRoute, private customerProposalService: customerProposalService, private createQuoteService: CreateQuoteService,
    private paymentService: PaymentPendingService, private el: ElementRef, private notifyService: NotificationService, public commonMethodService: CommonMethodService, private loaderService: LoaderService) { }

  ngOnInit() {
    this.currentDate = this.getCurrentDate();
    this.customerCommunicationDetails = new CustomerCommDetails(null, '', '', '', '', '', '', '', false, null, null, null, '', '', '', null, '', '', '');
    this.riskDetailsMarineOpen = new RiskDetailsMarineOpen();
    this.voyageDetails = new VoyageDetails('', '', [], []);
    this.maillingAddress = new mailingAddress('', '', '', '', '', '', '', '', '');
    this.customerDetails = new customerDetails('', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '');
    this.conditionsClausesWarrantiesExclusions = new conditionsClausesWarrantiesExclusions([], [], [], []);
    this.customerProposalTotalResponse = new MarineOpenProposalModal('', null, '', null, '', '', null, '', '', null, null, [], {}, '', '', '', '', '', '', null, this.customerDetails, this.maillingAddress, '', '', '', {}, '', '', this.conditionsClausesWarrantiesExclusions, '', '', '', '', '', '', '', '');
    this.agreementTypeData();
    this.getCCWEInfo();
    //console.log("fff=", this.generalFAQs);
    this.route.queryParams.subscribe(params => {
      if (params.hasOwnProperty('proposalNo')) {
        this.tempProposalNumber = params.proposalNo;
      } else {
        this.tempProposalNumber = params.proposalNumber;
      }
      this.isEndorsement = this.tempProposalNumber.includes('EN') ? true : false;
      this.isEndorsement ? this.proposalInput['endorsmentNumber'] = this.tempProposalNumber : this.proposalInput['proposalNumber'] = this.tempProposalNumber;
      this.proposalInput.proposalNumber = this.tempProposalNumber;
      this.getUploadedDocuments(this.tempProposalNumber);
      if (this.isEndorsement) {
        this.getEndorementTypes();
      }

      this.customerProposalService.getPaymentByAgentBehalfIndicator(this.proposalInput).subscribe(res => {
        this.isPaymentByAgentBehalfIndicator = res;
      });
      if (Object.keys(params).length > 1) {
        this.paymentResponse = params;
        this.updateTransactionDetailsAfterPayment();

      }
    });

    this.getProposalById();
    this.getCustomerTypeList();
    this.getMasterDataForMO();
    setTimeout(() => {
      this.tooltipInit();
    }, 2000);

    setTimeout(() => {
      this.tooltipInit();
    }, 6000);

    setTimeout(() => {
      this.tooltipInit();
    }, 10000);

  }

  getCCWEInfo() {
    this.newQuoteService.getCCWEInfoMarineOpen().subscribe(res => {
      this.CCWEInfo = res;
    });
  }
  getNumberInDecimal(value) {
    return parseFloat(value).toFixed(2);
  }

  onChangeCustomerType(customerType) {
    if (customerType == 'I') {
      this.isCustomerTypeInvalid = false;
      this.commonService.getSalutation('Individual').subscribe(res => {
        this.salutationList = res;
        this.salutationList = this.salutationList.keyValuePairList.keyValuePairList;
      });
    } else if (customerType == 'C') {
      //   // this.isCustomerTypeInvalid = true;
      this.salutationList = [{
        name: 'M/S'
      }
      ];
    }
  }

  saveEditCustomerProposal(editForm) {
    //console.log("editeddata=", editForm.value);
    this.customerProposalEditParams.ProposalNumber = this.customerProposalTotalResponse.proposalNumber;
    this.customerProposalService.saveMarineOpenEditCustomerProposalDetails(this.customerProposalEditParams)
      .subscribe(
        res => {
          this.isEditCustomerProposal = false;
          this.isCheckSelected = false;
          this.customerProposalService.getMarineOpenCustomerProposalDetails(this.tempProposalNumber).subscribe((res: any) => {
            this.customerDetailsList = res.inputRequest;
            //console.log("ccdd=", this.customerDetailsList);
            this.customerProposalTotalResponse = res;
            this.customerDetailsList.riskDetails.voyageExpectedDate = this.datepipe.transform(
              this.customerDetailsList.riskDetails.voyageExpectedDate,
              'dd/MM/yyyy'
            );
            if (this.isEndorsement) {
              this.notifyService.showSuccess('Endorsement ' + this.marineOpenProposalModel.endorsementNumber + ' ' + 'saved successfully', 'Endorsement Notification');
            } else {
              this.notifyService.showSuccess('Customer Profile updated successfully', 'Customer Profile Notification');
            }
          }
          );
          setTimeout(() => {
            this.tooltipInit();
          }, 1000);

          setTimeout(() => {
            this.tooltipInit();
          }, 4000);
        }
      );
  }




  getUploadedDocuments(proposalNumber) {
    // this.newProposalService.getUploadedDocuments(proposalNumber).subscribe(res => {
    //   this.uploadedDocumentList = res;
    //   this.uploadedDocumentCount = this.uploadedDocumentList != null ? this.uploadedDocumentList.length : 0;
    //   this.prepareUploadedFileData();
    // });
  }

  prepareUploadedFileData() {
    const uniqueDocTypeList = [];
    if (this.uploadedDocumentCount > 0) {
      this.uploadedDocumentList.forEach(docData => {
        if (!(uniqueDocTypeList.indexOf(docData.docType) > -1)) {
          uniqueDocTypeList.push(docData.docType);
        }
      });
      for (const docType of uniqueDocTypeList) {
        this.docDataSet[docType] = this.uploadedDocumentList.filter(docData => docData.docType == docType);
      }
      for (const docType in this.docDataSet) {
        const docListObj = new UploadedFileObj();
        docListObj.docName = docType;
        let temp = [];
        temp = this.docDataSet[docType];
        docListObj.docsCount = temp.length;
        if (docListObj.docsCount == 1) {
          docListObj.docRealFileName = temp[0].actualFileName;
        }
        temp.forEach((doc, index, temp) => {

          if ('docComment' in doc) {
            if (doc['docComment'] != '') {
              docListObj.comments = docListObj.comments + doc['docComment'] + ';';
            }
          }
          if (index == 0) {
            docListObj.lastUploadedBy = doc['uploadedby'];
            docListObj.lastUploadedDate = doc['date'];
            if (temp.length == 1) {
              docListObj.uuid = doc['uuid'];
            }
          } else {
            if (new Date(docListObj.lastUploadedDate) < new Date(doc['date'])) {
              docListObj.lastUploadedDate = doc['date'];
              docListObj.lastUploadedBy = doc['uploadedby'];
            }
          }
        });
        this.uploadedFilesList.push(docListObj);
      }
    }
  }


  onVoyageTypeChangeRisk(event, pIndex) {
    this.masterDataForMarine.VOYAGE_TYPE.forEach((ele, index) => {
      if (pIndex == index) {
        if (event) {
          // let tempObj: RiskDetailsMarineOpen = new RiskDetailsMarineOpen();
          // tempObj.voyageTypeLookupValue = ele.lookupValue;
          // tempObj.voyageType = ele.lookupValue;
          // this.commodityDetails = new CommodityDetails('', '', '', '', '', '', '');
          // tempObj.overrageExtra = new OverrageExtra('', '');
          // this.commodityDetails.commodityCode = 'ECN';
          // if (this.marineOpenProposalModel.riskDetails.length === 0) {
          //   tempObj.commodityDetails.push(this.commodityDetails);
          //   this.marineOpenProposalModel.riskDetails.push(tempObj);
          // } else {
          //   this.marineOpenProposalModel.riskDetails[0]['commodityDetails'].push(this.commodityDetails);

          // }

          ele.checked = true;
          let tempObj: RiskDetailsMarineOpen = new RiskDetailsMarineOpen();
          tempObj.voyageTypeLookupValue = ele.lookupValue;
          tempObj.voyageType = ele.lookupValue;
          tempObj.commodityDetails.push(new CommodityDetails('', '', '', '', '', '', ''));
          this.customerProposalEditParams.riskDetails.push(tempObj);

        } else {
          ele.checked = false;
          this.customerProposalEditParams.riskDetails.forEach((X, cindex) => {
            if (X.voyageTypeLookupValue == ele.lookupValue) {
              this.customerProposalEditParams.riskDetails.splice(cindex, 1);
            }
          });
        }
      }
    });
  }
  getQuoteByID(quoteId) {
    this.newQuoteService.getQuoteForMarineOpen(quoteId).subscribe((res) => {
      if (res) {
        this.quoteDetails = res;
        if ('customerDetails' in this.quoteDetails) {
          this.customerDetails = this.quoteDetails.customerDetails;
          // this.customerSetailsMappingFromshareQuote();
        } else {
          this.customerDetails = null;
        }
        // this.quoteStatus = this.quoteDetails.status;
        this.prepopulateBasicDetails();
        this.filtersLoaded = Promise.resolve(true);
      }
    });

  };
  agreementTypeData() {
    this.commonService.agreementTypeData().subscribe(res => {
      this.agreementData = res;
    });
  }
  getCurrentDate() {
    var currentDate = new Date();
    return currentDate.setDate(currentDate.getDate());
  }
  prepopulateBasicDetails() {
    this.riskFeature = new RiskFeature('', '', '', '', '', '');
    this.deductable = new DeductibleDetails('', '', '', '', '', '', '');
    this.marineOpenProposalModel.customerDetails.gstExemptionCategory = 'No Exemption';
    this.quoteDetails.inputRequest.riskDetails.forEach(riskDetail => {
      riskDetail.overrageExtra = this.overrageExtra;
      riskDetail.riskFeature = this.riskFeature;
      riskDetail.deductibleDetails = this.deductable;
      riskDetail.voyageDetails.typeofLandConveyanc = [];
      riskDetail.voyageTypeLookupValue = riskDetail.voyageType;


    })
    this.marineOpenProposalModel.riskDetails = this.quoteDetails.inputRequest.riskDetails;
    this.mapVoyageType();
    this.mapModeOfConveyance();
    this.marineOpenProposalModel.product = this.quoteDetails.inputRequest.product;
    this.marineOpenProposalModel.lineOfBusiness = this.quoteDetails.inputRequest.lineOfBusiness;
    this.marineOpenProposalModel.LobCode = this.quoteDetails.inputRequest.LobCode;
    this.marineOpenProposalModel.ProductCode = this.quoteDetails.inputRequest.ProductCode;
    this.marineOpenProposalModel.typeOfBusiness = this.quoteDetails.inputRequest.typeOfBusiness;
  }
  mapVoyageType() {
    this.voyageTypes.forEach(type => {
      this.customerProposalEditParams.riskDetails.forEach(riskDetail => {
        if (riskDetail['voyageType'] === type.lookupValue) {
          type.checked = true;
        }
      });
    });
  }
  mapVoyageTypeEdit() {
    this.voyageTypes.forEach(type => {
      this.customerProposalEditParams.riskDetails.forEach(riskDetail => {
        if (riskDetail['voyageType'] === type.lookupValue) {
          type.checked = true;
        }
      });
    });
  }

  mapModeOfConveyance() {
    this.masterDataForMarine.MODE_OF_CONVEYANCE.forEach(type => {
      if (this.marineOpenProposalModel.riskDetails[0]['voyageDetails']['modeOfCoveyance'].length > 0) {
        this.marineOpenProposalModel.riskDetails.forEach(riskDetail => {
          riskDetail['voyageDetails']['modeOfCoveyance'].forEach(modOfCov => {
            if (modOfCov === type.lookupValue) {
              type.checked = true;
            }
          });

        });
      }
    });
  }
  onTypesOfLandConeyanceChange(event, riskIndex, pIndex) {
    this.masterDataForMarine.TYPE_OF_LAND_CONVEYANCE.forEach((ele, index) => {
      if (pIndex == index) {
        if (event) {
          ele.checked = true;
          //this.marineOpenProposalModel.riskDetails[pIndex]['voyageDetails'] = new VoyageDetails('', '', [],[]);
          this.marineOpenProposalModel.riskDetails[riskIndex]['voyageDetails']['typeofLandConveyanc'].push(ele.lookupValue);
        } else {
          ele.checked = false;
          this.marineOpenProposalModel.riskDetails[riskIndex]['voyageDetails']['typeofLandConveyanc'].forEach((modeOfConv, cindex) => {
            if (modeOfConv == ele.lookupValue) {
              this.marineOpenProposalModel.riskDetails[riskIndex]['voyageDetails']['typeofLandConveyanc'].splice(cindex, 1);
            }
          });
        }
      }
    });
  }
  addAnotherCommodity(riskIndex) {
    this.customerProposalEditParams.riskDetails[riskIndex].commodityDetails.push(new CommodityDetails('', '', '', '', '', '', ''));
  }
  removeCommodity(riskIndex, commodityIndex) {
    if (this.customerProposalEditParams.riskDetails[riskIndex].commodityDetails.length > 1) {
      this.customerProposalEditParams.riskDetails[riskIndex].commodityDetails.splice(commodityIndex, 1);
    }
  }
  autoGrowTextZone(e) {
    e.target.style.height = "0px";
    e.target.style.height = (e.target.scrollHeight + 15) + "px";
  }

  onVoyageTypeChange(event) {
    //console.log(event);
    let tempaArr: any = ['Inland', 'Export:FOB/CFR', 'Export (other than EXW/FOB/CFR)'];
    let tempArr2: any = ["Cross Voyage (Mercantile Trade/Third country exports)", "Duty Only", "Import(other than CIF/CIP)", "(Import-CIF/CIP (Tail-end)"];
    let tempArr3: any = ["Inland", "Duty Only", "Import(other than CIF/CIP)", "(Import-CIF/CIP (Tail-end)"];
    if (tempaArr.indexOf(event) > -1) {
      this.customerProposalEditParams.voyageRoute.originatingCountry =
        this.masterDataForMarine.COUNTRY_TYPE.find(x => x.lookupValue === 'India').lookupValue;
    }
    if (tempArr3.indexOf(event) > -1) {
      this.customerProposalEditParams.voyageRoute.destinationCountey =
        this.masterDataForMarine.COUNTRY_TYPE.find(x => x.lookupValue === 'India').lookupValue;
    }
    if (tempArr2.indexOf(event) > -1) {
      this.customerProposalEditParams.voyageRoute.originatingCountry = '';
      this.customerProposalEditParams.voyageRoute.destinationCountey = '';
    }
    // by default invoice currency should be INR
    this.customerProposalEditParams.sumInsuredDetails.currencyOfInvoice = (event == 'Inland') ?
      this.masterDataForMarine.CURRENCY_TYPE.find(x => x.lookupDescription === 'Indian rupee').lookupValue : '';
    this.customerProposalEditParams.sumInsuredDetails.exchangeRate = (event == 'Inland') ? 1 : '';
  }

  onModeOfConeyanceChange(event, riskIndex, iModOfConv) {
    this.masterDataForMarine.MODE_OF_CONVEYANCE.forEach((ele, index) => {
      if (iModOfConv == index) {
        if (event) {
          ele.checked = true;
          if (ele.lookupValue === 'Rail/Road') {
            this.showTypeOfLandConveyance = true;
          }
          // this.marineOpenProposalModel.riskDetails[pIndex]['voyageDetails'] = new VoyageDetails('', '', []);
          this.marineOpenProposalModel.riskDetails[riskIndex]['voyageDetails']['modeOfCoveyance'].push(ele.lookupValue);
        } else {
          ele.checked = false;
          this.marineOpenProposalModel.riskDetails[riskIndex]['voyageDetails']['modeOfCoveyance'].forEach((modeOfConv, cindex) => {
            if (modeOfConv == ele.lookupValue) {
              if (ele.lookupValue === 'Rail/Road') {
                this.showTypeOfLandConveyance = false;
              }
              this.marineOpenProposalModel.riskDetails[riskIndex]['voyageDetails']['modeOfCoveyance'].splice(cindex, 1);
            }
          });
        }
      }
    });
  }

  getMasterDataForMO() {
    let imdcode = this.commonService.getUserName();
    this.commonService.getMasterDataForMarineOpen(34, 3411, imdcode).subscribe((res) => {
      this.masterDataForMarine = res;
      //console.log("mmdata=", this.masterDataForMarine);
      this.voyageTypes = this.masterDataForMarine.VOYAGE_TYPE;
      this.customerProposalEditParams.typeOfBusiness =
        this.masterDataForMarine.BUSINESS_TYPE.find(x => x.lookupDescription === 'New Business').lookupValue;
    });
  }
  getCustomerTypeList() {
    this.commonService.getCustomerType().subscribe(res => {
      this.customerTypeList = res;
    });
  }
  updateTransactionDetailsAfterPayment() {
    this.proposalsToPolicyParams.proposalNos.push(localStorage.getItem('gc_proposalNo'));
    this.proposalsToPolicyParams.partnerproposalNos.push(localStorage.getItem('ProposalNumber'));
    this.proposalsToPolicyParams.officeCode = null;
    this.proposalsToPolicyParams.paymentBy = 'INTERMEDIARY';
    this.proposalsToPolicyParams.transactionDetails.amount = this.paymentResponse.amount;
    this.proposalsToPolicyParams.transactionDetails.email = this.paymentResponse.email;
    this.proposalsToPolicyParams.transactionDetails.error = this.paymentResponse.error;
    this.proposalsToPolicyParams.transactionDetails.hashCode = this.paymentResponse.hash;
    this.proposalsToPolicyParams.transactionDetails.mId = this.paymentResponse.mihpayid;
    this.proposalsToPolicyParams.transactionDetails.mode = this.paymentResponse.mode;
    this.proposalsToPolicyParams.transactionDetails.payerCustomerId = localStorage.getItem('CustomerID');
    this.proposalsToPolicyParams.transactionDetails.pgType = this.paymentResponse.PG_TYPE;
    this.proposalsToPolicyParams.transactionDetails.status = this.paymentResponse.status;
    this.proposalsToPolicyParams.transactionDetails.transactionId = this.paymentResponse.txnid;
    this.proposalsToPolicyParams.transactionDetails.unmappedStatus = this.paymentResponse.unmappedstatus;
    if (this.proposalsToPolicyParams.transactionDetails.status == 'success') {
      this.isCustomerProposalMakePaymentSuccess = true;
      this.notifyService.showSuccess('Payment has been completed successfully, policy details will be shared soon', 'Payment Notification');
      this.commonService.getToken().subscribe(
        (token) => {
          this.proposalsToPolicyParams.tokenId = token;
          this.commonService.convertProposalToPolicyOnPaymentSuccess(this.proposalsToPolicyParams).subscribe(paymentres => {
            this.notifyService.showSuccess(paymentres + '.', 'Policy Notification');
          });
        });
    }
  }


  autoPopulateFields(event, riskIndex, cindex) {
    this.onCommodityChanges(riskIndex, cindex);
    if (this.masterDataForMarine.COMMODITY_TYPE && this.masterDataForMarine.COMMODITY_TYPE.length > 0) {
      if (event !== 'Select') {
        this.masterDataForMarine.COMMODITY_TYPE.forEach((commodity) => {
          if (commodity.gcShortDesc === event) {
            this.marineOpenProposalModel.riskDetails[riskIndex].commodityDetails[cindex]['cargosegment'] = commodity.otherDesc;
            this.marineOpenProposalModel.riskDetails[riskIndex].commodityDetails[cindex]['cargoLongDescription'] = commodity.gcLongDesc;
            this.marineOpenProposalModel.riskDetails[riskIndex].commodityDetails[cindex]['packagingShortDescription'] = commodity.lookupValue;
            this.marineOpenProposalModel.riskDetails[riskIndex].commodityDetails[cindex]['packagingLongDescription'] = commodity.lookupDescription;
          }
        });
      } else {

        this.marineOpenProposalModel.riskDetails[riskIndex].commodityDetails[cindex]['cargosegment'] = '';
        this.marineOpenProposalModel.riskDetails[riskIndex].commodityDetails[cindex]['cargoLongDescription'] = '';
        this.marineOpenProposalModel.riskDetails[riskIndex].commodityDetails[cindex]['packagingShortDescription'] = '';
        this.marineOpenProposalModel.riskDetails[riskIndex].commodityDetails[cindex]['packagingLongDescription'] = '';

      }
    }

  }


  onCommodityChanges(riskIndex, ci) {
    this.masterDataForMarine.COMMODITY_TYPE.forEach((ele, index) => {
      if (ci == index) {
        this.marineOpenProposalModel.riskDetails[riskIndex]['commodityDetails'][ci]['commodityCode'] = ele.lookupValue
      }
    })
  }

  formatdocName(docName) {
    return docName.replace(/_/g, ' ');
  }

  rotateIcon(iconId: number) {
    switch (iconId) {
      case 0:
        this.setRotate0 = !this.setRotate0;
        break;
      case 1:
        this.setRotate1 = !this.setRotate1;
        break;
      case 2:
        this.setRotate2 = !this.setRotate2;
        break;
      case 3:
        this.setRotate3 = !this.setRotate3;
        break;
      case 4:
        this.setRotate4 = !this.setRotate4;
        break;
      case 5:
        this.setRotate5 = !this.setRotate5;
        break;
      case 6:
        this.setRotate6 = !this.setRotate6;
        break;
      case 7:
        this.setRotate7 = !this.setRotate7;
        break;
      case 8:
        this.setRotate8 = !this.setRotate8;
        break;
      case 9:
        this.setRotate9 = !this.setRotate9;
        break;
    }

    setTimeout(() => {
      this.tooltipInit();
    }, 2000);
    setTimeout(() => {
      this.tooltipInit();
    }, 4000);
    setTimeout(() => {
      this.tooltipInit();
    }, 7000);

  }
  tooltipInit() {
    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
  }
  // Only AlphaNumeric
  keyPressAlphaNumeric(event) {

    var inp = String.fromCharCode(event.keyCode);

    if (/[a-zA-Z0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  editCustomerproposal() {
    if (this.isEndorsement) {
      this.selectedEndorsementType(event, type);
      this.disableControls = true;
      this.disableAllEn = true;
    }
    this.getMasterDataForQuote();
    this.tooltipInit();
    setTimeout(() => {
      this.tooltipInit();
    }, 3000);
    this.disableControls = true;
    this.customerProposalService.getMarineOpenCustomerProposalDetails(this.tempProposalNumber).subscribe((res: any) => {
      this.customerProposalEditParams = res.inputRequest;
      //console.log(this.customerProposalEditParams)
      this.customerProposalEditParams.sumInsured = this.commonMethodService.formatNumberToINR(this.customerProposalEditParams.sumInsured);
      this.customerProposalList.proposalNumber = res.proposalNumber;
      this.customerProposalRateList = res;
      if (res.inputRequest.EndorsementTypes) {
        this.setEndorsementType(res.inputRequest.EndorsementTypes);
      }
      this.policyStartDate = this.customerProposalRateList.inputRequest.policyStartDate;
      this.policyStartDate = this.policyStartDate.substring(6) + '-' + this.policyStartDate.substring(3, 5) + '-' + this.policyStartDate.substring(0, 2);
      this.policyEndDate = this.customerProposalRateList.inputRequest.policyEndDate;
      this.policyEndDate = this.policyEndDate.substring(6) + '-' + this.policyEndDate.substring(3, 5) + '-' + this.policyEndDate.substring(0, 2);
      this.isEditCustomerProposal = true;
      // this.customerProposalEditParams.riskDetails.voyageExpectedDate = this.customerProposalEditParams.riskDetails.voyageExpectedDate.substring(6) + '-' + this.customerProposalEditParams.riskDetails.voyageExpectedDate.substring(3, 5) + '-' + this.customerProposalEditParams.riskDetails.voyageExpectedDate.substring(0, 2);
      if (this.isEndorsement) {
        this.mapVoyageTypeEdit();
      } else {
        this.mapVoyageType();
      }
      this.customerTypeMappingForMO();
      //   this.customerTypeReMapping();
      this.DateofBirthEditProposal = this.customerProposalRateList.inputRequest.customerDetails.dateOfBirth;
      this.DateofBirthEditProposal = this.DateofBirthEditProposal.substring(6) + '-' + this.DateofBirthEditProposal.substring(3, 5) + '-' + this.DateofBirthEditProposal.substring(0, 2);
      this.financierList = res.inputRequest.financier.financierDetails;
      this.invoiceList = res.inputRequest.InvoiceDetails;
      this.customer = res.inputRequest.customerDetails.customerType;
    });
  }

  getMasterDataForQuote() {
    let imdcode = this.commonService.getUserName();
    this.commonService.getMasterDataForMarineOpen(21, this.productCode, imdcode).subscribe((res) => {
      this.masterDataForQuote = res;
    });
  }

  calculateTotals() {
    let total: number = 0;
    if (this.marineProposalModel.sumInsuredDetails.exchangeRate && this.marineProposalModel.sumInsuredDetails.cargoSIInCurrencyOfInvoice) {
      total = this.marineProposalModel.sumInsuredDetails.exchangeRate * this.marineProposalModel.sumInsuredDetails.cargoSIInCurrencyOfInvoice;
    }
    this.marineProposalModel.sumInsuredDetails.cargoSumInsuredINR = total;
    this.marineProposalModel.sumInsuredDetails.totalSumInsured = total;
  }

  downloadCustomerProposalDataBrochure() {
    this.dataToDownloadBrochure.productCode = '21';
    this.commonService.downloadCustomerProposalDataBrochure(this.dataToDownloadBrochure).subscribe(
      (res) => {
        this.dataForPdf = res;
        this.blob = new Blob([this.dataForPdf], { type: 'application/pdf' });
        const downloadURL = window.URL.createObjectURL(this.blob);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = 'Brochure.pdf';
        link.click();
      },
      (error: HttpErrorResponse) => {
      }
    );
  }

  downloadCustomerPolicyWordings() {
    this.dataToDownloadPolicyWordings.productCode = this.customerDetailsList.ProductCode;
    this.commonService.downloadCustomerProposalDataBrochure(this.dataToDownloadPolicyWordings).subscribe(
      (res) => {
        this.dataForPdf = res;
        this.blob = new Blob([this.dataForPdf], { type: 'application/pdf' });
        const downloadURL = window.URL.createObjectURL(this.blob);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = 'PolicyWordings.pdf';
        link.click();
      },
      (error: HttpErrorResponse) => {
      }
    );
  }

  onCheckTerms() {
    this.isCheckSelected = !this.isCheckSelected;
  }



  rejectProposalButton() {
    this.isCustomerRejectionCommentsInvalid = false;
  }

  // clearSearchText() {
  //   this.searchText = '';
  // }

  CancelEditButton() {
    this.isEditCustomerProposal = false;
    this.isCheckSelected = false;
    setTimeout(() => {
      this.tooltipInit();
    }, 1000);
  }

  requestAgentPayment() {
    this.customerProposalService.requestAgentToMakePaymentMarineOpen(this.tempProposalNumber).subscribe((res: any) => {
      this.ifRequestAgentToPayment = true;
    }
    );
  }

  makePayment() {
    this.isCustomerProposalMakePayment = true;
    this.inputForPayment.paymentDetails.amount = this.customerProposalTotalResponse.brmsResponse.totalPremium;
    this.inputForPayment.paymentDetails.emailAddress = this.customerDetailsList.customerDetails.emailId;
    this.inputForPayment.paymentDetails.firstName = this.customerDetailsList.customerDetails.nameOfCorporate;
    this.inputForPayment.paymentDetails.phoneNumber = this.customerDetailsList.customerDetails.mobileNumber.toString();
    this.inputForPayment.paymentDetails.proposalNo = localStorage.getItem('ProposalNumber');
    this.inputForPayment.paymentDetails.productInfo = this.customerDetailsList.product;
    this.paymentService.getTransactionId().subscribe(
      (res) => {
        this.inputForPayment.paymentDetails.transactionId = res.toString();
        this.createQuoteService.makePayment(this.inputForPayment).subscribe(
          (res) => {
            const myWindow = window.open('', '_self');
            myWindow.document.write(res);
          },
          (error: HttpErrorResponse) => {
          }
        );
      },
      (error: HttpErrorResponse) => {
      }
    );
  }

  convertNumberToINR(numToInr) {
    return this.commonMethodService.formatNumberToINR(numToInr);
  }

  getOtpForProposalAcceptance() {
    if (this.isCheckSelected == true) {
      this.customerDetailsForValidateOtpParams.otp = '';
      this.isOTPInvalid = false;
      this.isOTPTimedOut = false;
      this.customerDetailsForGetOtpParams.customerId = this.commonService.getUserName();
      this.customerDetailsForGetOtpParams.customerLastName = this.customerDetailsList.customerDetails.lastName;
      this.customerDetailsForGetOtpParams.salutation = this.customerDetailsList.customerDetails.salutation;
      this.customerDetailsForGetOtpParams.proposalNumber = this.customerProposalTotalResponse.proposalNumber;
      this.customerDetailsForGetOtpParams.emailId = this.customerDetailsList.customerDetails.emailId;
      this.customerDetailsForGetOtpParams.mobileNumber = this.customerDetailsList.customerDetails.mobileNumber;
      this.customerDetailsForGetOtpParams.productId = this.customerDetailsList.ProductCode;
      this.customerDetailsForGetOtpParams.productName = this.customerDetailsList.product;
      if (this.tempProposalNumber.includes('EN')) {
        this.customerDetailsForGetOtpParams.endorsementNumber = this.customerProposalTotalResponse.endorsementNumber;
        this.customerDetailsForGetOtpParams.modeofOperation = this.customerProposalTotalResponse.inputRequest.ModeOfOperation;
      } else {
        this.customerDetailsForGetOtpParams.modeofOperation = this.customerProposalTotalResponse.inputRequest.ModeOfOperation;
      }

      this.customerProposalService.getOtpForMarineCustomerproposalAcceptanceForMarineOpen(this.customerDetailsForGetOtpParams).subscribe((res) => {
        this.acceptProposalOtpResponse = res;
      });
    } else {
      this.notifyService.showInfo('Please confirm the declaration before accepting the proposal', 'Customer Profile Notification');
    }
  }

  acceptedProposal() {
    this.emptyFieldError = false;
    if (this.customerDetailsForValidateOtpParams.otp == '') {
      this.emptyFieldError = true;
    } else {
      this.isOTPInvalid = false;
      this.isOTPTimedOut = false;
      this.customerDetailsForGetOtpParams.customerId = this.customerDetailsList.customerDetails.customerID;
      this.customerDetailsForValidateOtpParams.customerLastName = this.customerDetailsList.customerDetails.lastName;
      this.customerDetailsForValidateOtpParams.salutation = this.customerDetailsList.customerDetails.salutation;
      this.customerDetailsForValidateOtpParams.proposalNumber = this.customerProposalTotalResponse.proposalNumber;
      this.customerDetailsForValidateOtpParams.mobileNumber = this.customerDetailsList.customerDetails.mobileNumber;
      this.customerDetailsForValidateOtpParams.productId = this.customerDetailsList.ProductCode;
      this.customerDetailsForValidateOtpParams.productName = this.customerDetailsList.product;
      if (this.tempProposalNumber.includes('EN')) {
        this.customerDetailsForValidateOtpParams.endorsementNumber = this.customerProposalTotalResponse.endorsementNumber;
        this.customerDetailsForValidateOtpParams.modeofOperation = this.customerProposalTotalResponse.inputRequest.ModeOfOperation;
      } else {
        this.customerDetailsForValidateOtpParams.modeofOperation = this.customerProposalTotalResponse.inputRequest.ModeOfOperation;
      }
      this.customerProposalService.validateOtpForMarineOpenCustomerproposalAcceptance(this.customerDetailsForValidateOtpParams).subscribe((res) => {
        switch (res) {
          case 'OTP Valid': this.customerProposalService.getPaymentByAgentBehalfIndicator(this.proposalInput).subscribe(res => {
            this.isPaymentByAgentBehalfIndicator = res;
            $('#AcceptProposal').modal('hide');
            this.ifProposalAccepted = true;
          });
            break;
          case 'OTP Invalid': this.isOTPInvalid = true;
            this.isOTPTimedOut = false;
            break;
          case 'OTP Expired': this.isOTPTimedOut = true;
            this.isOTPInvalid = false;
            break;
        }
      });
    }
  }

  removeFinancier(financierIndex) {
    if (financierIndex !== 0) {
      this.financierList.splice(financierIndex, 1);
    }
    else {
      this.notifyService.showError('At least one record of Financier is required.', '')
    }
  }

  addAnotherFinancier() {
    let temp: any = {};
    this.financierList.push(temp);
  }

  NumberOnlyInput(event) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  removeModelData() {
    this.customerDetails = null;
    this.searchParams.imdCode = "";
    this.searchParams.token = "";
  }

  onCurrencyChange(event) {
    this.commonService.getCurrencyRates(event.target.value).subscribe((res) => {
      this.marineProposalModel.sumInsuredDetails.exchangeRate = res[event.target.value].currencyRate;
    });
  }

  isfinancierDetailsFormValid(formValid: any) {
    this.financierDetailsFormValid = formValid;
  }

  getProposalById() {
    this.ifRequestAgentToPayment = false;
    this.isPinCodeValid = true;
    this.searchParams.imdCode = this.commonService.getUserName();
    this.searchParams.token = this.token;
    this.customerProposalService.getMarineOpenCustomerProposalDetails(this.tempProposalNumber + '').subscribe((res: any) => {
      this.filtersLoaded = Promise.resolve(true);
      this.proposalDataByNumber = res;
      this.customerDetailsList = res.inputRequest;
      this.onChangeCustomerType(this.customerDetailsList.customerDetails.customerType);
      //console.log("ccdd=", this.customerDetailsList);
      this.customerProposalTotalResponse = res;
      this.marineOpenProposalModel = res;

      if (this.customerDetailsList.typeOfBusiness == 'Roll Over') {
        this.previousPolicyData = this.customerDetailsList.PASTPOLICY['PASTPOLICYDETAILS'];
        if (!('conditions' in this.customerProposalTotalResponse)) {
          this.customerProposalTotalResponse.conditions = [];
        }
      }

      this.customerTypeMappingForMO();

      localStorage.setItem('gc_proposalNo', res.gcProposalNumber);
      localStorage.setItem('CustomerID', res.customerId);
      localStorage.setItem('ProposalNumber', res.proposalNumber);
      this.maskedMobileNumber = this.customerDetailsList.customerDetails.mobileNumber.toString().replace(/^(\d{3})\d(?=\d{3})|\d(?=\d{3})/g, '$1*');
      if ('oldPolicyDetails' in this.customerProposalTotalResponse) {
        this.newPolicyDetails = this.customerProposalTotalResponse.inputRequest;
        this.oldPolicyDetails = this.customerProposalTotalResponse.oldPolicyDetails;
        this.commonMethodService.filterAndAddBothValues(((this.commonMethodService.arrangeDataArr(this.commonMethodService.getKeyValues(this.newPolicyDetails)).flat())).flat(Infinity),
          ((this.commonMethodService.arrangeDataArr(this.commonMethodService.getKeyValues(this.oldPolicyDetails)).flat())).flat(Infinity));
      }
      //console.log(this.customerProposalTotalResponse);
      if (this.customerProposalTotalResponse.status == 'Rejected by Customer' || this.customerProposalTotalResponse.status == 'EN Rejected by customer') {
        this.ifProposalRejected = true;
      } else if
        (this.customerProposalTotalResponse.status == 'Payment Pending' || this.customerProposalTotalResponse.status == 'EN Pending Payment') {
        this.ifProposalAccepted = true;
      } else if (this.customerProposalTotalResponse.status == '') {
        this.isCustomerProposalMakePaymentSuccess = true;
      }
      if (this.customerProposalTotalResponse.isAgentPayment == true) {
        this.ifRequestAgentToPayment = true;
      } else {
        this.ifRequestAgentToPayment = false;
      }
      if (this.customerProposalTotalResponse.isPaymentBehalfCustomer) {
        this.isPaymentBehalfCustomer = false;
      } else {
        this.isPaymentBehalfCustomer = true;
      }
      if (this.ifProposalAccepted == true || this.customerProposalTotalResponse.status == 'In force') {
        this.isCheckSelected = true;
      }
      this.tooltipInit();
      // this.formatblAwbLRrrCnDate = this.customerDetailsList.miscellaneousDetails.blAwbLRrrCnDate;
      // this.customerDetailsList.miscellaneousDetails.blAwbLRrrCnDate = this.datepipe.transform(
      //   this.customerDetailsList.miscellaneousDetails.blAwbLRrrCnDate,
      //   'dd/MM/yyyy'
      // );
      // this.customerDetailsList.miscellaneousDetails.lcDate = this.datepipe.transform(
      //   this.customerDetailsList.miscellaneousDetails.lcDate,
      //   'dd/MM/yyyy'
      // );
      // this.customerDetailsList.riskDetails.voyageExpectedDate = this.datepipe.transform(
      //   this.customerDetailsList.riskDetails.voyageExpectedDate,
      //   'dd/MM/yyyy'
      // );
    }
    );
  }

  autoPopulateOverageExtra(event, riskIndex) {
    if (this.masterDataForMarine.VESSEL_TYPE_OR_AGE_BAND && this.masterDataForMarine.VESSEL_TYPE_OR_AGE_BAND.length > 0) {
      this.masterDataForMarine.VESSEL_TYPE_OR_AGE_BAND.forEach((vesselType) => {
        if (vesselType.lookupValue === event) {
          this.marineOpenProposalModel.riskDetails[riskIndex]['overrageExtra'].loading = vesselType.otherDesc;
        }
      })
    }

  }

  customerTypeMappingForMO() {
    // this.marineOpenProposalModel.customerDetails.customerType = this.customerDetailsList.customerDetails.customerType.toUpperCase();
    // if (this.marineOpenProposalModel.customerDetails.customerType == 'INDIVIDUAL' || this.marineOpenProposalModel.customerDetails.customerType == 'I') {
    //   this.marineOpenProposalModel.customerDetails.customerType = 'I';
    //   this.onChangeCustomerType('I');
    // } else if (this.marineOpenProposalModel.customerDetails.customerType == 'CORPORATE' || this.marineOpenProposalModel.customerDetails.customerType == 'C') {
    //   this.marineOpenProposalModel.customerDetails.customerType = 'C';
    //   this.onChangeCustomerType('C');
    // } else if (this.marineOpenProposalModel.customerDetails.customerType == 'GOVT.UNDERTAKING') {
    //   this.marineOpenProposalModel.customerDetails.customerType = 'G';
    //   this.onChangeCustomerType('G');
    // }
    // this.marineOpenProposalModel.customerDetails.salutation = this.marineOpenProposalModel.customerDetails.salutation.toUpperCase();
  }
  clearSearchText() {
    this.searchText = '';
  }
  rejectProposal() {

    if (this.customerProposalTotalResponse.status == 'Rejected by Customer') {
      this.ifProposalRejected = true;
    } else {
      if (this.customerRejectCommentsDetails.comment == '') {
        this.isCustomerRejectionCommentsInvalid = true;
        return;
      }

      this.rejectCustomerProposal.customerName = this.customerDetailsList.customerDetails.nameOfCorporate;
      this.rejectCustomerProposal.customerLastName = this.customerDetailsList.customerDetails.nameOfCorporate;
      this.rejectCustomerProposal.proposalNo = this.customerProposalTotalResponse.proposalNumber;
      if (this.customerDetailsList.intermediaryDetails.salutation == '') {
        this.rejectCustomerProposal.salutation = 'MR';
      } else {
        this.rejectCustomerProposal.salutation = this.customerDetailsList.intermediaryDetails.salutation;
      }
      this.rejectCustomerProposal.partnerMobileNumber = this.customerDetailsList.intermediaryDetails.mobileNumber;
      this.rejectCustomerProposal.productName = this.customerDetailsList.product;
      this.rejectCustomerProposal.productId = this.customerDetailsList.ProductCode;
      this.rejectCustomerProposal.status = 'Rejected by Customer';
      this.rejectCustomerProposal.intermediaryID = this.customerDetailsList.intermediaryDetails.IntermediaryID;
      this.rejectCustomerProposal.partnerLastName = this.customerDetailsList.intermediaryDetails.firstName;
      this.rejectCustomerProposal.partnerEmail = this.customerDetailsList.intermediaryDetails.emailId;
      this.customerRejectCommentsDetails.createdBy = this.rejectCustomerProposal.customerName;
      this.customerRejectCommentsDetails.userCode = this.customerDetailsList.customerDetails.customerID;
      this.rejectCustomerProposal.endorsmentNumber = this.customerProposalTotalResponse.endorsmentNumber;
      this.rejectCustomerProposal.modeofOperation = this.customerDetailsList.ModeOfOperation;

      this.customerRejectCommentsDetails.time = formatDate(new Date(), 'dd/MM/yyyy h:mm:ss a', 'en-us');
      this.rejectCustomerProposal.custCommentsDetails.push(this.customerRejectCommentsDetails);

      this.commonService.rejectCustomerProposalMarineOpen(this.rejectCustomerProposal).subscribe(success => {
        this.ifProposalRejected = true;
        $('#RejectProposal').modal('hide');
      },
        error => {
        }
      );
    }
  }

  getEndorementTypes() {
    this.commonService.getEndorsementTypeList('2153')
      .subscribe((res) => {
        this.endorementTypeList = res;

        //console.log("endorementTypeList-", this.endorementTypeList);
      });
  }


  selectedEndorsementType(event, endorsementType) {
    this.selectedType = event.target.value;
    this.isUPDateGSTNChecked = (event.currentTarget.checked == true && endorsementType == 'Update GSTN') ?
      true : (event.currentTarget.checked == false && endorsementType == 'Update GSTN') ? false : this.isUPDateGSTNChecked;
    this.isChangeinClientDetailsChecked = (event.currentTarget.checked == true && endorsementType == 'Change in Client Details') ?
      true : (event.currentTarget.checked == false && endorsementType == 'Change in Client Details') ? false : this.isChangeinClientDetailsChecked;
    this.isAnyOtherNilEndorsementChecked = (event.currentTarget.checked == true && endorsementType == 'Any other Nil Endorsement') ?
      true : (event.currentTarget.checked == false && endorsementType == 'Any other Nil Endorsement') ? false : this.isAnyOtherNilEndorsementChecked;
    this.isAnyOtherNonNilEndorsementChecked = (event.currentTarget.checked == true && endorsementType == 'Any other NonNil Endorsement') ?
      true : (event.currentTarget.checked == false && endorsementType == 'Any other NonNil Endorsement') ? false : this.isAnyOtherNonNilEndorsementChecked;
    this.isChangeinDeductibleChecked = (event.currentTarget.checked == true && endorsementType == 'Change in Deductible') ?
      true : (event.currentTarget.checked == false && endorsementType == 'Change in Deductible') ? false : this.isChangeinDeductibleChecked;
    this.isChangeInDeclarationChecked = (event.currentTarget.checked == true && endorsementType == 'Declaration Endorsement') ?
      true : (event.currentTarget.checked == false && endorsementType == 'Declaration Endorsement') ? false : this.isChangeInDeclarationChecked;
    this.isincresedSumInsuredChecked = (event.currentTarget.checked == true && endorsementType == 'Increase in Sum Insured') ?
      true : (event.currentTarget.checked == false && endorsementType == 'Increase in Sum Insured') ? false : this.isincresedSumInsuredChecked;
  }
  setEndorsementType(endorsementType) {
    if (endorsementType.includes('Change in Client Details')) {
      this.isChangeinClientDetailsChecked = true;
    }
    if (endorsementType.includes('Update GSTN')) {
      this.isUPDateGSTNChecked = true;
    }
    if (endorsementType.includes('Change in Deductible')) {
      this.isChangeinDeductibleChecked = true;
    }
    if (endorsementType.includes('Any Other Nil Endorsement')) {
      this.isAnyOtherNilEndorsementChecked = true;
      this.isInclusionofFinancierChecked = true;
    }


  }

  spliceEndorsementTypes(endorsementType) {
    this.selectedEndorsementTypes.forEach((element, index) => {
      if (element == endorsementType) {
        this.selectedEndorsementTypes.splice(index, 1);
      }
    });
  }

  mappingForEndorsement() {
    this.notNilEndorsement = false;
    this.selectedEndorsementTypes = [];
    this.selectedEndorsementTypes.forEach(item => {
      this.endorementTypeList.forEach(type => {
        if (item == type.endorsementType) {
          if (type.endorsementCategory == 'NOT NIL ENDORSEMENT') {
            this.notNilEndorsement = true;
          }
        }
      })
    })

    if (this.notNilEndorsement) {
      this.marineOpenProposalModel['ModeOfOperation'] = 'NotNilEndorsement';
      this.marineOpenProposalModel['EndorsementName'] = 'Any Other NonNil Endorsement';
      this.marineOpenProposalModel['EndorsementCode'] = '25';
      this.marineOpenProposalModel['EndtCalcType'] = 'Pro Rata';
      this.marineOpenProposalModel['EndorsementTime'] = '00:00';
      this.marineOpenProposalModel['EndorsementWording'] = 'Wording Endt Nil';
    } else {
      this.marineOpenProposalModel['ModeOfOperation'] = 'NilEndorsement';
      this.marineOpenProposalModel['EndorsementName'] = 'Any Other Nil Endorsement';
      this.marineOpenProposalModel['EndorsementCode'] = '24';
      this.marineOpenProposalModel['EndtCalcType'] = '';
      this.marineOpenProposalModel['EndorsementTime'] = '00:00';
      this.marineOpenProposalModel['EndorsementWording'] = 'Wording Endt Nil';
    }

    // this.marineProposalModel['ENCCWEChangeComment'] = this.CCEWValue;
    this.marineOpenProposalModel['EndorsementDate'] = this.datepipe.transform(
      this.EndorsementDate,
      'dd/MM/yyyy'
    );
    // this.marineProposalModel['NoOfClaimsProcessed'] = this.proposalDataByNumber.inputRequest.InputXML.NoOfClaimsProcessed;
    this.marineOpenProposalModel['ProposalNo'] = this.proposalDataByNumber.inputRequest.gcProposalNumber;
    //this.marineOpenProposalModel['ProposalNumber'] = this.proposalDataByNumber.inputRequest.proposalNumber;
    this.marineOpenProposalModel['ProposalNumber'] = 'P18052136110000037';
    this.marineOpenProposalModel['policyNumber'] = this.proposalDataByNumber.inputRequest.policyNumber;
    this.marineOpenProposalModel['EndorsementTypes'] = this.selectedEndorsementTypes;
    // this.marineProposalModel.UserRole = 'ADMIN';
    // this.marineProposalModel.UserId = 'O1000130';

    // this.marineProposalModel.customerDetails['middleName'] =
    //     'middleName' in this.marineProposalModel.customerDetails ? this.marineProposalModel.customerDetails['middleName'] : '';
    // this.marineProposalModel.IsEditableRateRequired = "False";
    if ('premiumData' in this.proposalDataByNumber.inputRequest)
      // this.marineProposalModel.totalPremium = this.proposalDataByNumber.inputRequest.premiumData.totalPremium
      this.marineOpenProposalModel.businessSourceType = 'Intermediary';
    this.marineOpenProposalModel['QuotationNumber'] = null;
    // this.marineOpenProposalModel.IntermediaryID = this.commonService.getUserName();
    this.marineOpenProposalModel.intermediaryDetails = {};
    this.marineOpenProposalModel.intermediaryDetails['IntermediaryID'] = this.commonService.getUserName();
    if (this.customerDetailsList.intermediaryDetails.salutation == '') {
      this.marineOpenProposalModel.intermediaryDetails['salutation'] = 'MR';
    } else {
      this.marineOpenProposalModel.intermediaryDetails['salutation'] = this.customerDetailsList.intermediaryDetails.salutation;
    }
    this.marineOpenProposalModel.intermediaryDetails['firstName'] = this.customerDetailsList.intermediaryDetails.firstName;
    this.marineOpenProposalModel.intermediaryDetails['middleName'] = this.customerDetailsList.intermediaryDetails.middleName;
    this.marineOpenProposalModel.intermediaryDetails['lastName'] = this.customerDetailsList.intermediaryDetails.lastName;
    this.marineOpenProposalModel.intermediaryDetails['emailId'] = this.commonService.getUserEmail();
    this.marineOpenProposalModel.intermediaryDetails['mobileNumber'] = this.commonService.getUserMobileNumber();
    this.marineOpenProposalModel.intermediaryDetails['servicingBranch'] = this.customerDetailsList.intermediaryDetails.servingBranchName;
    this.marineOpenProposalModel.intermediaryDetails['salesManagerFirstName'] = this.customerDetailsList.intermediaryDetails.smFirstname;
    this.marineOpenProposalModel.intermediaryDetails['salesManagerLastName'] = this.customerDetailsList.intermediaryDetails.smLastName;
    this.marineOpenProposalModel.intermediaryDetails['salesManagerEmail'] = '';
    this.marineOpenProposalModel.intermediaryDetails['salesManagerMobNo'] = '';
    this.marineOpenProposalModel.intermediaryDetails['salesManagerSalutation'] = '';
    this.marineOpenProposalModel.intermediaryDetails['salesManagerNid'] = '';
    this.marineOpenProposalModel.intermediaryDetails['salesManagerAltMobNo'] = '';
    this.marineOpenProposalModel.intermediaryDetails['channel'] = '';
  }

  setEndorsementSelected(event) {
    if (this.isAtleastOneEndorsmentNotSelected) {
      this.isAtleastOneEndorsmentNotSelected = false;
    }
  }

  scrollToFirstInvalidControl() {
    this.firstInvalidControl = this.el.nativeElement.querySelector(
      "form .ng-invalid"
    );
    if (this.firstInvalidControl != null) {
      if (!this.firstInvalidControl.closest(".lmig-Accordion-content").classList.contains("show")) {
        this.firstInvalidControl.closest(".lmig-Accordion-content").classList.add("show");
      }
      $(this.firstInvalidControl).focus();
    }
  }

  dateFormatCheck(str) {
    const t = str.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (t === null) {
      return false;
    }
    const d = +t[1];
    const m = +t[2];
    const y = +t[3];

    if (m >= 1 && m <= 12 && d >= 1 && d <= 31) {
      return true;
    }

    return false;
  }

  onChangePincodeData(val: string) {
    this.isPinCodeValid = true;
    if (val.trim() != '') {
      this.promise = new Promise<void>((resolve, reject) => {
        this.newQuoteService.getPincodeMasterData(val)
          .toPromise()
          .then(
            res => {
              this.PinCodeList = res;

              if (this.PinCodeList.length == 0) {
                this.pinCodeSearchCleared();
              }
              if (val.length <= 5) {
                this.pinCodeminError();
              } else {
                this.pinCodeminError1();
              }
              resolve();
            }
          );
      });
    }
    return this.promise;
  }

  selectPincode(item) {
    this.isPinCodeValid = true;
    this.newQuoteService.getPincodeDataOnSelect(item).subscribe(res => {
      if (Object.keys(res).length != 0) {
        this.marineOpenProposalModel.mailingAddress.mailingPinCode = item;
        this.PincodeMasterData = res;
        this.marineOpenProposalModel.mailingAddress.mailingDistrict = this.PincodeMasterData.cityDistrictName;
        this.marineOpenProposalModel.mailingAddress.mailingDistrictCd = this.PincodeMasterData.cityDistrictCode;
        this.marineOpenProposalModel.mailingAddress.mailingState = this.PincodeMasterData.stateName;
        this.marineOpenProposalModel.mailingAddress.mailingStateCd = this.PincodeMasterData.stateCode;
        this.marineOpenProposalModel.mailingAddress.mailingTownOrCity = this.PincodeMasterData.cityDistrictName;
        this.marineOpenProposalModel.LocationID = this.PincodeMasterData.locationCode;
      } else {
        this.pinCodeSearchCleared();
      }
    });
  }
  pinCodeSearchCleared() {
    this.PincodeMasterData = null;
    this.PinCodeList = null;
    this.isPinCodeValid = false;
  }

  pinCodeminError() {
    this.pincodeminlimit = true;
  }
  pinCodeminError1() {
    this.pincodeminlimit = false;
  }


  onKeyUpValidationForField(fieldName) {
    switch (fieldName) {
      case 'dob':
        if ((new Date().getFullYear() - new Date(this.DateOfBirthToSavePeoposal).getFullYear()) < 18) {
          this.isDobInvalid = true;
        } else {
          this.isDobInvalid = false;
        }
        break;
      case 'dobFuture':
        if (
          (new Date(this.DateOfBirthToSavePeoposal)) > (new Date(this.getToday()))
        ) {
          this.dobFutureDate = true;
        } else {
          this.dobFutureDate = false;
        }
        break;

      default:
        break;
    }
  }

  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }
  prevoiusPolicyDatescheck() {
    this.isPolicyDateInvalid = false;
    if (this.policyEndDateToSavePeoposal != '' && this.policyEndDateToSavePeoposal != null && this.policyStartDateToSavePeoposal != '' && this.policyStartDateToSavePeoposal != null) {
      if (new Date(this.policyEndDateToSavePeoposal) > new Date(this.policyStartDateToSavePeoposal)) {
        this.isPolicyDateInvalid = false;
        //return true;
      } else {
        this.isPolicyDateInvalid = true;
        //return false;
      }
    }
  }

  setendDate() {
    if (this.marineOpenProposalModel.policyPeriod = 'Annual') {
      //console.log("date", this.policyStartDate);
      // this.date = this.policyStartDateToSavePeoposal;

      // const PolicyStartDate = this.date;
      this.policyStartDate = this.datepipe.transform(
        this.policyStartDate,
        'yyyy-MM-dd');
      const policyStartYear = parseFloat(this.policyStartDate.toString().substring(0, 4));
      const policyStartMonth = parseFloat(this.policyStartDate.toString().substring(5, 7));
      const policyStartDay = parseFloat(this.policyStartDate.toString().substring(8));
      const endDate = new Date(policyStartYear + 1, policyStartMonth - 1, policyStartDay);
      endDate.setDate(endDate.getDate() - 1);
      this.policyEndDate = this.datepipe.transform(
        endDate,
        'yyyy-MM-dd');
      this.marineOpenProposalModel.policyEndDate = this.policyEndDate;
      this.marineOpenProposalModel.policyStartDate = this.policyStartDate;
      this.policyStartDate = this.marineOpenProposalModel.policyStartDate;
      this.policyEndDate = this.marineOpenProposalModel.policyEndDate;
      this.prevoiusPolicyDatescheck()
    }
  }
}
